export type ReportDownloadFileParams = {
  fileName: string;
  result: BlobPart;
  type?: string;
};

export type ReportOpenFileParams = {
  fileName: string;
  fileType: string;
  result: BlobPart;
};

export type ReportCallback = (result: BlobPart) => void;

function useReportGenerate() {
  const downloadFile = (params: ReportDownloadFileParams) => {
    const url = window.URL.createObjectURL(
      new Blob([params.result], { type: params.type }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', params.fileName);
    link.click();
    link.remove();
  };

  const openFile = (params: ReportOpenFileParams) => {
    const url = URL.createObjectURL(
      new Blob([params.result], { type: params.fileType }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.download = params.fileName;
    window.open(link.href);
    link.remove();
  };

  return { downloadFile, openFile };
}

export default useReportGenerate;
